<script lang="ts">
    import {Spacer} from 'shared/layouts';
    import type {ReportTemplate} from 'src/typings';
    import {SingularFileViewer, createMediaViewerOnlineFile} from 'src/features/media-viewer';
    import {FileViewForm} from 'shared/constants';
    import type {ExportFilePreviewData} from './types';
    import {exists} from 'shared/utils/custom-utils';
    import {getReportServerContext} from 'src/features/report-server/report-server-context';
    import {createEventDispatcher} from 'svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    export let filePreviewData: ExportFilePreviewData | null;
    export let exportData: Record<string, any>;
    export let selectedTemplate: ReportTemplate;

    const context = getReportServerContext();
    const dispatch = createEventDispatcher<{ 'close': void }>();

    let loading = false;

    const handleCloseClick = () => {
        dispatch('close');
    };

    const handleExportToRecordFilesClick = async () => {
        loading = true;
        await context.service.saveExportToRecordFiles(context.record, selectedTemplate, exportData);
        loading = false;
    };

    const handleDownloadClick = async () => {
        loading = true;
        await context.service.downloadExport(selectedTemplate, exportData);
        loading = false;
    };
</script>

<div class="action-buttons-container">
    <KpButton on:click={handleCloseClick}>
        <IconedContent icon="arrow-left">Zavřít</IconedContent>
    </KpButton>

    <Spacer flex="1"/>

    <KpButton buttonStyle="brand-orange" isLoading={loading} on:click={handleExportToRecordFilesClick}>
        <IconedContent icon="file-export">Exportovat k souborům záznamu</IconedContent>
    </KpButton>

    <KpButton buttonStyle="primary" isLoading={loading} on:click={handleDownloadClick}>
        <IconedContent icon="download">Stáhnout</IconedContent>
    </KpButton>
</div>

<div class="verbis-viewer-container">
    {#if exists(filePreviewData)}
        {@const file = createMediaViewerOnlineFile(filePreviewData.fileUrl, filePreviewData.viewForm)}

        {#if filePreviewData.viewForm === FileViewForm.PDF || filePreviewData.viewForm === FileViewForm.SPREADSHEET}
            <SingularFileViewer {file}/>
        {:else}
            <IconedContent icon="info"
                           align="center"
                           justify="center"
                           orientation="vertical"
                           fillAvailableSpace>

                Zatím není implementován náhled pro tento typ souboru ({filePreviewData.viewForm})
            </IconedContent>
        {/if}
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro-erp.less";

    .action-buttons-container {
        display: flex;
        padding: @spacing-l @spacing-xxl;
        gap: @spacing-m;
        border-bottom: 1px solid @themed-border-default;
    }

    .verbis-viewer-container {
        .flex-grow();
    }
</style>